import { objectUtils } from "@flights/web-api-utils-universal";
export const transformDisclaimersForExtras = (extras) => objectUtils
    .getObjectKeys(extras)
    .reduce((acc, extraKey) => {
    if (extras[extraKey]) {
        if (extraKey === "specialBag") {
            acc.push(...extras[extraKey]?.map((specialBag) => specialBag.price));
        }
        else {
            acc.push(extras[extraKey].price);
        }
    }
    return acc;
}, [])
    .flatMap((priceBreakdown) => transformDisclaimersForPriceBreakdown(priceBreakdown));
export const transformDisclaimersForPriceBreakdown = (priceBreakdown) => {
    return (priceBreakdown?.bcomPricingItems || [])?.reduce((acc, bcomPricingItem) => {
        if (bcomPricingItem.disclaimer?.trim()) {
            acc.push(bcomPricingItem.disclaimer.trim());
        }
        return acc;
    }, []);
};
